import * as React from 'react'

import { OutlineGlassBackgroundCard } from 'components/outline-glass-background-card/OutlineGlassBackgroundCard'
import { Text, TextName } from 'sdk/text/Text'

import type { AboutLeadershipMemberCmsContent } from 'core/services/cms/interfaces'

import classes from './LeadershipTeamCard.module.scss'

interface ComponentProps {
  leader: AboutLeadershipMemberCmsContent
}

export const LeadershipTeamCard: React.FC<ComponentProps> = ({ leader }) => {
  const [isFlipped, setIsFlipped] = React.useState(false)

  const handleClick = (): void => {
    setIsFlipped(!isFlipped)
  }

  return (
    <div className={classes.cardWrapper} onClick={handleClick}>
      <div className={`${classes.flipper} ${isFlipped ? classes.flipped : ''}`}>
        {/* Front Side */}
        <OutlineGlassBackgroundCard className={`${classes.card} ${classes.front}`}>
          <img src={leader.photoUrl} alt={leader.name} className={classes.photo} />
          <div className={classes.header}>
            <Text type={TextName.H2} className={classes.name}>
              {leader.name}
            </Text>
            <Text type={TextName.H3} className={classes.title}>
              {leader.role}
            </Text>
          </div>
          <div className={classes.bioContainer}>
            <Text type={TextName.Text} className={classes.bio}>
              {leader.bio}{' '}
              <span className={classes.readMore}>Read more</span>
            </Text>
          </div>
        </OutlineGlassBackgroundCard>

        {/* Back Side */}
        <OutlineGlassBackgroundCard className={`${classes.card} ${classes.back}`}>
          <div className={classes.backHeader}>
            <Text type={TextName.H2} className={classes.name}>
              {leader.name}
            </Text>
            <Text type={TextName.H3} className={classes.title}>
              {leader.role}
            </Text>
          </div>
          <Text type={TextName.Text} className={classes.backBio}>
            {leader.bio}
          </Text>
          <ul className={classes.resume}>
            {leader.resumePoints.map((item, index) => (
              <li key={index}>
                <Text type={TextName.Text}>{item}</Text>
              </li>
            ))}
          </ul>
        </OutlineGlassBackgroundCard>
      </div>
    </div>
  )
}
